import React, { useState, useEffect } from 'react'
import { Collapse, Divider, Grid, IconButton, Typography, Box } from '@mui/material'
import { ExpandMore, ExpandLess, Block } from '@mui/icons-material'

const GenericCollapsableSection = ({
  title,
  children,
  isOpenByDefault,
  disabled = false,
  disabledMessage = '',
}) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault && !disabled)

  // Sync `isOpen` with `isOpenByDefault` and `disabled` whenever they change
  useEffect(() => {
    setIsOpen(isOpenByDefault && !disabled)
  }, [isOpenByDefault, disabled])

  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen)
    }
  }

  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'grey.300',
        borderRadius: 2,
        mb: 3,
        boxShadow: isOpen ? 2 : 0,
        transition: 'box-shadow 0.3s',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <Grid
        container
        alignItems='center'
        justifyContent='space-between'
        onClick={handleToggle}
        sx={{
          backgroundColor: isOpen ? 'grey.100' : 'grey.50',
          p: '12px 16px',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        <Typography
          variant='subtitle1'
          sx={{
            fontWeight: 'bold',
            color: disabled
              ? 'text.disabled'
              : isOpen
                ? 'secondary.main'
                : 'text.primary',
          }}
        >
          {title}
        </Typography>
        <IconButton disabled={disabled}>
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Grid>
      
      <Collapse in={isOpen}>
        <Divider sx={{ mx: 1 }} />
        <Box sx={{ p: '20px 16px' }}>{children}</Box>
      </Collapse>
      
      {disabled && disabledMessage && (
        <Box sx={{ p: 2, backgroundColor: 'grey.50', color: 'text.secondary' }}>
          <Grid container alignItems='center'>
            <Block sx={{ mr: 1, color: 'error.main' }} />
            <Typography variant='body2'>{disabledMessage}</Typography>
          </Grid>
        </Box>
      )}
    </Box>
  )
}

export default GenericCollapsableSection
